'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CatSearchForm } from '@blocks-react/components/SearchForm';
import { CatIconSearch } from '@blocks-react/components/Icons/Search';
import { useEffect, useRef, useState } from 'react';
import styles from '../DealerLocator.module.scss';
import cx from 'classnames';
export const DealerLocatorSearchForm = ({ isVisible, children, value, placeholder, onSearch, onKeyPress, onCancel, mobileBreakPoint, isInputError, setIsInputError, isSearchLoading, locationSelected, isDisabled, isMobile, isStoreLocationMapViewUpdateFlag }) => {
    const [hasFocusedInput, setHasFocusedInput] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
        if (isVisible && !hasFocusedInput) {
            setIsActive(false);
            setHasFocusedInput(true);
            setTimeout(() => {
                ref?.current?.focus();
                if (locationSelected) {
                    // Auto-search for current selected store when the drawer is opened
                    onSearch(locationSelected);
                }
            }, 300);
        }
    }, [isVisible, onSearch, locationSelected, hasFocusedInput]);
    useEffect(() => {
        if (!isVisible) {
            setHasFocusedInput(false);
        }
    }, [isVisible]);
    const handleSearch = (searchText) => {
        ref.current?.blur();
        setIsActive(false);
        onSearch(searchText);
    };
    const onFocus = () => {
        if (isInputError && document.activeElement === ref.current) {
            setIsInputError(false);
        }
    };
    const handleChange = (searchText) => {
        if (searchText === null) {
            // User clicked on X button
            if (!isSearchLoading) {
                onCancel();
            }
            else {
                // Don't allow input clearance if results are loading
                onKeyPress(value);
            }
            setIsActive(false);
        }
        else {
            onKeyPress(searchText);
            setIsActive(!!searchText);
        }
    };
    return (_jsxs(CatSearchForm, { ref: ref, onClick: onFocus, isActive: isActive, onBlSearch: (e) => handleSearch(e.target.value), onBlChange: (e) => handleChange(e.detail.value), onBlSelect: (e) => handleSearch(e.target.value), onKeyUp: (e) => e.key === 'Enter' &&
            handleSearch(e.target.value), placeholder: placeholder, status: isInputError ? 'error' : undefined, mobileBreakPoint: mobileBreakPoint, "data-testid": "dealer-locator-search-form", value: value, isInline: true, position: "bottom-start", disabled: isDisabled, className: cx({
            [styles['search-bar']]: isStoreLocationMapViewUpdateFlag && isMobile
        }), children: [_jsx(CatIconSearch, { slot: "before" }), children] }));
};
